<div class="tab-pane active container-fluid" role="tabpanel" aria-labelledby="germplasm-search-tab">
    <div class="row p-0 m-0">
        <div class="col d-flex align-items-center justify-content-end">
            <button class="btn btn-outline-info pull-end" (click)="toggleListBuilder()" *jhiHasAnyAuthority="CREATE_GERMPLASM_LIST_PERMISSIONS">
                <i class="fa me-3" [ngClass]="listBuilderContext.visible ? 'fa-angle-right': 'fa-angle-left'"></i>
                <span *ngIf="listBuilderContext.visible" jhiTranslate="list-builder.hide"></span>
                <span *ngIf="!listBuilderContext.visible" jhiTranslate="list-builder.show"></span>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="d-flex">
                <jhi-column-filter [request]="request" [resultSearch]="resultSearch" [filters]="filters"
                                   class="flex-sm-grow-1"></jhi-column-filter>
            </div>
        </div>
    </div>
	<div class="row mb-3 mt-3">
        <div class="col-auto d-flex align-items-center mb-2">
				<jhi-item-count-custom [page]="page" [total]="filteredItems" [itemsPerPage]="itemsPerPage"
									   [limit]="isBrowseAllResults ? filteredItems+1 : 5000"></jhi-item-count-custom>
				<span style="padding-left: 5px;" class="fst-italic" *ngIf="hasIncludedGids()"
					  jhiTranslate="search-germplasm.included-gids"></span>
				<span style="margin-left: 20px;" jhiTranslate="common.selected">Selected:</span>
				<span style="padding-left: 5px;" class="fw-bold">
					<!-- includes gids not counted in filteredItems (e.g pedigree, group members)  -->
					{{isSelectAll ? (+filteredItems + (germplasmList.length > filteredItems ? germplasmList.length - filteredItems : 0)) : size(selectedItems)}}
				</span>
				<!-- An message indicating that there could be more items not included in this page  -->
				<span class="fst-italic" *ngIf="hasIncludedGids() && isSelectAll && filteredItems > itemsPerPage"
					  jhiTranslate="search-germplasm.included-gids"></span>
				<div class="form-check ms-3">
					<input class="form-check-input" [disabled]="isSelectAllDisabled()" type="checkbox" [title]="getSelectAllTooptip()"
						   [(ngModel)]="isSelectAll" (click)="onSelectAll(isSelectAll)" id="check-select-all" name="check-select-all" >
					<label class="form-check-label" for="check-select-all" jhiTranslate="global.select.all">
						Select all pages
					</label>
				</div>
                <div class="form-check ms-3">
                    <input class="form-check-input" type="checkbox" [ngbTooltip]="'search-germplasm.browse-all' | translate" [(ngModel)]="isBrowseAllResults" (click)="onBrowseAllResults(isBrowseAllResults)" id="check-browse-all-results" name="check-browse-all-results">
                    <label class="form-check-label" for="check-browse-all-results" jhiTranslate="search-germplasm.browse-all">
                        Browse all search results
                    </label>
                </div>
                @if (!isBrowseAllResults) {
                    <div class="ms-2">
                        <button class="btn btn-sm btn-outline-info" (click)="onClearSort($event)" jhiTranslate="global.clear-sort"></button>
                    </div>
                }
				<span *ngIf="isLoading" style="margin-left: 10px;" class="throbber"></span>
			</div>
        <div class="col d-flex align-items-center justify-content-end mb-2">
            <div ngbDropdown class="ms-2" placement="bottom-right">
                <button class="btn btn-info" id="actionMenu" ngbDropdownToggle jhiTranslate="actions"></button>
                <div ngbDropdownMenu aria-labelledby="actionMenu">
                    <button class="dropdown-item" type="submit"  jhiTranslate="search-germplasm.actions.create-list"
                            *jhiHasAnyAuthority="CREATE_GERMPLASM_LIST_PERMISSIONS"
                            (click)="openCreateList()" >
                    </button>
                    <button class="dropdown-item" type="submit"  jhiTranslate="search-germplasm.actions.add-to-list"
                            *jhiHasAnyAuthority="ADD_GERMPLASM_ENTRIES_TO_LIST_PERMISSIONS"
                            (click)="openAddToList()" >
                    </button>
                    <button class="dropdown-item" type="submit"  jhiTranslate="search-germplasm.actions.import"
                            *jhiHasAnyAuthority="IMPORT_GERMPLASM_PERMISSIONS"
                            [routerLink]="['/', { outlets: { popup: 'germplasm-import'} }]"
                            [replaceUrl]="true"
                            queryParamsHandling="merge">
                    </button>
                    <button class="dropdown-item" type="submit" *jhiHasAnyAuthority="IMPORT_GERMPLASM_UPDATES_PERMISSIONS"
                            [routerLink]="['/', { outlets: { popup: 'germplasm-import-update-dialog'} }]"
                            [replaceUrl]="true"
                            queryParamsHandling="merge" jhiTranslate="germplasm-import-updates.title">
                    </button>
                    <button class="dropdown-item" type="submit"  *jhiHasAnyAuthority="DELETE_GERMPLASM_PERMISSIONS"  jhiTranslate="search-germplasm.actions.delete-germplasm"
                            (click)="deleteGermplasm()" >
                    </button>
                    <button class="dropdown-item" type="submit"  *jhiHasAnyAuthority="MERGE_GERMPLASM_PERMISSIONS"  jhiTranslate="search-germplasm.actions.merge-germplasm"
                            (click)="mergeGermplasm()" >
                    </button>
                    <button class="dropdown-item" type="submit"  *jhiHasAnyAuthority="GERMPLASM_LABEL_PRINTING_PERMISSIONS" jhiTranslate="search-germplasm.actions.export-data-and-labels"
                            (click)="exportDataAndLabels()">
                    </button>
                    <!-- TODO: consolidate into one main Grouping menu item (IBP-5227) -->
                    <button class="dropdown-item" type="submit"  *jhiHasAnyAuthority="GROUP_GERMPLASM_PERMISSIONS" jhiTranslate="search-germplasm.actions.group"
                            (click)="groupGermplasm()" >
                    </button>
                    <button class="dropdown-item" type="submit"  *jhiHasAnyAuthority="UNGROUP_GERMPLASM_PERMISSIONS" jhiTranslate="search-germplasm.actions.ungroup"
                            (click)="ungroupGermplasm()" >
                    </button>
                    <button class="dropdown-item" type="submit" *jhiHasAnyAuthority="CODE_GERMPLASM_PERMISSIONS" jhiTranslate="search-germplasm.actions.code-germplasm"
                            (click)="openGermplasmCoding()">
                    </button>
                    <button class="dropdown-item" type="submit" jhiTranslate="search-germplasm.actions.create-inventory-lots"
                            *jhiHasAnyAuthority="CREATE_INVENTORY_LOT_PERMISSIONS"
                            (click)="openCreateLots()">
                    </button>
                </div>
            </div>
            <jhi-germplasm-columns class="ms-2" [hiddenColumns]="hiddenColumns"
                                   (columnsSelectedEvent)="onColumnsSelected($event)">
            </jhi-germplasm-columns>
        </div>
	</div>
    <div class="row" *ngIf="isSelectAllDisabled()" >
        <div class="col">
            <div class="alert alert-warning" role="alert">
                <i class="fa fa-warning pe-2"></i>
                <span jhiTranslate="search-germplasm.browse-all.warning.filter.required" [translateValues]="{ param: SELECT_BROWSE_ALL_RESULTS_MAX_SIZE }"></span>
            </div>
        </div>
    </div>
	<div class="table-responsive" *ngIf="germplasmList">
		<table data-test="germplasmSearchResultsTable" class="table table-striped table-bordered table-curved" *ngIf="germplasmList.length else nodata">
			<thead>
			<tr jhiSort [(predicate)]="predicate" [(ascending)]="reverse" [callback]="sort.bind(this)">
				<th *ngIf="!isSelectAll"><input type="checkbox" class="form-check-input" [ngbTooltip]="'global.select.current.page' | translate" [checked]="isPageSelected()" (click)="onSelectPage()" [title]="'global.select.current.page' | translate" data-test="checkSelectCurrentPage"></th>
				<th [hidden]="hiddenColumns[ColumnLabels.GID]">
					<span *ngIf="!isBrowseAllResults" [jhiSortBy]="ColumnLabels.GID">
						<span jhiTranslate="search-germplasm.column.gid"></span>
						<span class="fa fa-sort"></span>
					</span>
					<span *ngIf="isBrowseAllResults">
						<span jhiTranslate="search-germplasm.column.gid"></span>
					</span>
				</th>
				<th [hidden]="hiddenColumns[ColumnLabels['GERMPLASM UUID']]">
					<span *ngIf="!isBrowseAllResults" [jhiSortBy]="ColumnLabels['GERMPLASM UUID']">
						<span jhiTranslate="search-germplasm.column.germplasmUUID"></span>
						<span class="fa fa-sort"></span>
					</span>
					<span *ngIf="isBrowseAllResults">
						<span jhiTranslate="search-germplasm.column.germplasmUUID"></span>
					</span>
				</th>
				<th [hidden]="hiddenColumns[ColumnLabels['GROUP ID']]">
					<span *ngIf="!isBrowseAllResults" [jhiSortBy]="ColumnLabels['GROUP ID']">
						<span jhiTranslate="search-germplasm.column.groupId" data-test="groupIdHeader"></span>
						<span class="fa fa-sort"></span>
					</span>
					<span *ngIf="isBrowseAllResults">
						<span jhiTranslate="search-germplasm.column.groupId" data-test="groupIdHeader"></span>
					</span>
				</th>
				<th *jhiHasAnyAuthority="VIEW_NAMES_PERMISSION" [hidden]="hiddenColumns[ColumnLabels.NAMES]">
					<span *ngIf="!isBrowseAllResults" [jhiSortBy]="ColumnLabels.NAMES" >
						<span jhiTranslate="search-germplasm.column.names"></span>
						<span class="fa fa-sort"></span>
					</span>
					<span *ngIf="isBrowseAllResults">
						<span jhiTranslate="search-germplasm.column.names"></span>
					</span>
				</th>
				<th [hidden]="hiddenColumns[ColumnLabels.AVAILABLE]">
					<span *ngIf="!isBrowseAllResults" [jhiSortBy]="ColumnLabels.AVAILABLE" >
						<span jhiTranslate="search-germplasm.column.availableBalance"></span>
						<span class="fa fa-sort"></span>
					</span>
					<span *ngIf="isBrowseAllResults">
						<span jhiTranslate="search-germplasm.column.availableBalance"></span>
					</span>
				</th>
				<th [hidden]="hiddenColumns[ColumnLabels.LOT_UNITS]">
					<span *ngIf="!isBrowseAllResults" [jhiSortBy]="ColumnLabels.LOT_UNITS" >
						<span jhiTranslate="search-germplasm.column.unit"></span>
						<span class="fa fa-sort"></span>
					</span>
					<span *ngIf="isBrowseAllResults">
						<span jhiTranslate="search-germplasm.column.unit"></span>
					</span>
				</th>
				<th [hidden]="hiddenColumns[ColumnLabels.LOTS]"><span jhiTranslate="search-germplasm.column.lotCount"></span></th>
				<th [hidden]="hiddenColumns[ColumnLabels.CROSS]" *ngIf="showProgenitorNamesColumn()"><span jhiTranslate="search-germplasm.column.pedigreeString">CROSS</span></th>
				<th [hidden]="hiddenColumns[ColumnLabels['PREFERRED ID']]">
					<span *ngIf="!isBrowseAllResults" [jhiSortBy]="ColumnLabels['PREFERRED ID']" >
						<span jhiTranslate="search-germplasm.column.germplasmPreferredId"></span>
						<span class="fa fa-sort"></span>
					</span>
					<span *ngIf="isBrowseAllResults">
						<span jhiTranslate="search-germplasm.column.germplasmPreferredId"></span>
					</span>
				</th>
				<th *jhiHasAnyAuthority="VIEW_NAMES_PERMISSION" [hidden]="hiddenColumns[ColumnLabels['PREFERRED NAME']]">
					<span *ngIf="!isBrowseAllResults" [jhiSortBy]="ColumnLabels['PREFERRED NAME']" >
						<span jhiTranslate="search-germplasm.column.germplasmPreferredName">PREFERRED NAME</span>
						<span class="fa fa-sort"></span>
					</span>
					<span *ngIf="isBrowseAllResults">
						<span jhiTranslate="search-germplasm.column.germplasmPreferredName">PREFERRED NAME</span>
					</span>
				</th>
				<th [hidden]="hiddenColumns[ColumnLabels['GERMPLASM DATE']]">
					<span *ngIf="!isBrowseAllResults" [jhiSortBy]="ColumnLabels['GERMPLASM DATE']"  >
					<span jhiTranslate="search-germplasm.column.germplasmDate"></span>
					<span class="fa fa-sort"></span>
					</span>
					<span *ngIf="isBrowseAllResults">
						<span jhiTranslate="search-germplasm.column.germplasmDate"></span>
					</span>
				</th>
				<th [hidden]="hiddenColumns[ColumnLabels.LOCATIONS]">
					<span *ngIf="!isBrowseAllResults" [jhiSortBy]="ColumnLabels.LOCATIONS" >
						<span jhiTranslate="search-germplasm.column.locationName"></span>
						<span class="fa fa-sort"></span>
					</span>
					<span *ngIf="isBrowseAllResults">
						<span jhiTranslate="search-germplasm.column.locationName"></span>
					</span>
				</th>
				<th [hidden]="hiddenColumns[ColumnLabels['METHOD NAME']]">
					<span *ngIf="!isBrowseAllResults" [jhiSortBy]="ColumnLabels['METHOD NAME']" >
						<span jhiTranslate="search-germplasm.column.methodName"></span>
						<span class="fa fa-sort"></span>
					</span>
					<span *ngIf="isBrowseAllResults">
						<span jhiTranslate="search-germplasm.column.methodName"></span>
					</span>
				</th>
				<th [hidden]="hiddenColumns[ColumnLabels['METHOD ABBREV']]">
					<span *ngIf="!isBrowseAllResults" [jhiSortBy]="ColumnLabels['METHOD ABBREV']" >
						<span jhiTranslate="search-germplasm.column.methodCode"></span>
						<span class="fa fa-sort"></span>
					</span>
					<span *ngIf="isBrowseAllResults">
						<span jhiTranslate="search-germplasm.column.methodCode"></span>
					</span>
				</th>
				<th [hidden]="hiddenColumns[ColumnLabels['METHOD NUMBER']]">
					<span *ngIf="!isBrowseAllResults" [jhiSortBy]="ColumnLabels['METHOD NUMBER']" >
						<span jhiTranslate="search-germplasm.column.methodNumber"></span>
						<span class="fa fa-sort"></span>
					</span>
					<span *ngIf="isBrowseAllResults">
						<span jhiTranslate="search-germplasm.column.methodNumber"></span>
					</span>
				</th>
				<th [hidden]="hiddenColumns[ColumnLabels['METHOD GROUP']]">
					<span *ngIf="!isBrowseAllResults" [jhiSortBy]="ColumnLabels['METHOD GROUP']" >
						<span jhiTranslate="search-germplasm.column.methodGroup"></span>
						<span class="fa fa-sort"></span>
					</span>
					<span *ngIf="isBrowseAllResults">
						<span jhiTranslate="search-germplasm.column.methodGroup"></span>
					</span>
				</th>
				<th [hidden]="hiddenColumns[ColumnLabels['FGID']]" *jhiHasAnyAuthority="VIEW_PEDIGREE_INFORMATION_PERMISSION"><span jhiTranslate="search-germplasm.column.femaleParentGID"></span></th>
				<th [hidden]="hiddenColumns[ColumnLabels['CROSS-FEMALE PREFERRED NAME']]" *ngIf="showProgenitorNamesColumn()"><span jhiTranslate="search-germplasm.column.femaleParentPreferredName"></span></th>
				<th [hidden]="hiddenColumns[ColumnLabels['MGID']]" *jhiHasAnyAuthority="VIEW_PEDIGREE_INFORMATION_PERMISSION"><span jhiTranslate="search-germplasm.column.maleParentGID"></span></th>
				<th [hidden]="hiddenColumns[ColumnLabels['CROSS-MALE PREFERRED NAME']]" *ngIf="showProgenitorNamesColumn()"><span jhiTranslate="search-germplasm.column.maleParentPreferredName"></span></th>
				<th [hidden]="hiddenColumns[ColumnLabels['GROUP SOURCE GID']]" *jhiHasAnyAuthority="VIEW_PEDIGREE_INFORMATION_PERMISSION">
					<span *ngIf="!isBrowseAllResults" [jhiSortBy]="ColumnLabels['GROUP SOURCE GID']" >
						<span jhiTranslate="search-germplasm.column.groupSourceGID"></span>
						<span class="fa fa-sort"></span>
					</span>
					<span *ngIf="isBrowseAllResults">
						<span jhiTranslate="search-germplasm.column.groupSourceGID"></span>
					</span>
				</th>
				<th [hidden]="hiddenColumns[ColumnLabels['GROUP SOURCE']]" *ngIf="showProgenitorNamesColumn()">
					<span *ngIf="!isBrowseAllResults" [jhiSortBy]="ColumnLabels['GROUP SOURCE']" >
						<span jhiTranslate="search-germplasm.column.groupSourcePreferredName"></span>
						<span class="fa fa-sort"></span>
					</span>
					<span *ngIf="isBrowseAllResults">
						<span jhiTranslate="search-germplasm.column.groupSourcePreferredName"></span>
					</span>
				</th>
				<th [hidden]="hiddenColumns[ColumnLabels['IMMEDIATE SOURCE GID']]" *jhiHasAnyAuthority="VIEW_PEDIGREE_INFORMATION_PERMISSION">
					<span *ngIf="!isBrowseAllResults" [jhiSortBy]="ColumnLabels['IMMEDIATE SOURCE GID']" >
						<span jhiTranslate="search-germplasm.column.immediateSourceGID"></span>
						<span class="fa fa-sort"></span>
					</span>
					<span *ngIf="isBrowseAllResults">
						<span jhiTranslate="search-germplasm.column.immediateSourceGID"></span>
					</span>
				</th>
				<th [hidden]="hiddenColumns[ColumnLabels['IMMEDIATE SOURCE']]" *ngIf="showProgenitorNamesColumn()">
					<span *ngIf="!isBrowseAllResults" [jhiSortBy]="ColumnLabels['IMMEDIATE SOURCE']" >
						<span jhiTranslate="search-germplasm.column.immediateSourceName"></span>
						<span class="fa fa-sort"></span>
					</span>
					<span *ngIf="isBrowseAllResults">
						<span jhiTranslate="search-germplasm.column.immediateSourceName"></span>
					</span>
				</th>
				<ng-container *ngIf="germplasmList[0]">
					<th *ngFor="let entry of germplasmList[0].attributeTypesValueMap | keyvalue">
						<span *ngIf="!isBrowseAllResults"  jhiSortBy="{{entry.key}}" >
							<span>{{entry.key}}</span>
							<span class="fa fa-sort"></span>
						</span>
						<span *ngIf="isBrowseAllResults">
							<span>{{entry.key}}</span>
						</span>
					</th>
				</ng-container>
				<ng-container *ngIf="showNamesColumn()">
					<th *ngFor="let entry of germplasmList[0].nameTypesValueMap | keyvalue">
						<span *ngIf="!isBrowseAllResults" jhiSortBy="{{entry.key}}" >
							<span>{{entry.key}}</span><span class="fa fa-sort"></span>
						</span>
						<span *ngIf="isBrowseAllResults">
							<span>{{entry.key}}</span>
						</span>
					</th>
				</ng-container>
			</tr>
			</thead>
			<tbody cdkDropList cdkDropListConnectedTo="listBuilderDrop" >
			<tr *ngFor="let germplasm of germplasmList; trackBy: trackId; index as index"
				[class.selected]="isSelected(germplasm)"
				(click)="toggleSelect($event, index, germplasm)"
                (mousedown)="preventDefaultOnShiftKey($event)"
				cdkDrag [cdkDragDisabled]="!listBuilderContext.visible" (cdkDragEntered)="dragStart($event, germplasm)">
				<div *cdkDragPlaceholder>&nbsp;</div>

				<td *ngIf="!isSelectAll"><input type="checkbox" class="form-check-input" [checked]="isSelected(germplasm)" (click)="toggleSelect($event, index, germplasm, true); $event.stopPropagation()"></td>
                <td [hidden]="hiddenColumns[ColumnLabels.GID]"><a class="link" (click)="germplasmDetailsPopupService.open(germplasm.gid)"><truncate-span [textInput]="germplasm.gid" [data-test]="'gidLink-' + germplasm.gid"></truncate-span></a></td>
				<td [hidden]="hiddenColumns[ColumnLabels['GERMPLASM UUID']]"><a class="link" (click)="germplasmDetailsPopupService.open(germplasm.gid)"><truncate-span [textInput]="germplasm.germplasmUUID"></truncate-span></a></td>
                <td [hidden]="hiddenColumns[ColumnLabels['GROUP ID']]"><a class="link" *ngIf="germplasm.groupId" (click)="germplasmDetailsPopupService.open(germplasm.groupId)" data-test="germplasmGroupIdLink"><truncate-span [textInput]="germplasm.groupId"></truncate-span></a><span *ngIf="!germplasm.groupId">-</span></td>
				<td [hidden]="hiddenColumns[ColumnLabels.NAMES]"><a class="link" (click)="germplasmDetailsPopupService.open(germplasm.gid)"><truncate-span [textInput]="germplasm.names" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></a></td>
				<td [hidden]="hiddenColumns[ColumnLabels.AVAILABLE]">{{germplasm.availableBalance}}</td>
				<td [hidden]="hiddenColumns[ColumnLabels.LOT_UNITS]">{{germplasm.unit}}</td>
				<td [hidden]="hiddenColumns[ColumnLabels.LOTS]">
					<a class="link" *ngIf="germplasm.lotCount" (click)="inventoryDetailsPopupService.open(germplasm.gid)">{{germplasm.lotCount}}</a>
					<span *ngIf="germplasm.lotCount === 0">-</span>
				</td>
				<td [hidden]="hiddenColumns[ColumnLabels.CROSS]" *ngIf="showProgenitorNamesColumn()"><truncate-span [textInput]="germplasm.pedigreeString" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></td>
				<td [hidden]="hiddenColumns[ColumnLabels['PREFERRED ID']]">{{germplasm.germplasmPreferredId}}</td>
				<td jhiScrollableTooltip [tooltipText]="germplasm.germplasmPreferredName" *jhiHasAnyAuthority="VIEW_NAMES_PERMISSION" placement="right" [hidden]="hiddenColumns[ColumnLabels['PREFERRED NAME']]"><truncate-span [textInput]="germplasm.germplasmPreferredName" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></td>
				<td [hidden]="hiddenColumns[ColumnLabels['GERMPLASM DATE']]">{{germplasm.germplasmDate}}</td>
				<td [hidden]="hiddenColumns[ColumnLabels.LOCATIONS]"><a (click)="$event.stopPropagation()" [routerLink]="['/', { outlets: { popup: 'location/' + germplasm.locationId } }]" queryParamsHandling="merge">{{germplasm.locationName}}</a></td>
				<td [hidden]="hiddenColumns[ColumnLabels['METHOD NAME']]"><a (click)="$event.stopPropagation()" [routerLink]="['/', { outlets: { popup: 'breeding-method/' + germplasm.breedingMethodId } }]" queryParamsHandling="merge">{{germplasm.methodName}}</a></td>
				<td [hidden]="hiddenColumns[ColumnLabels['METHOD ABBREV']]">{{germplasm.methodCode}}</td>
				<td [hidden]="hiddenColumns[ColumnLabels['METHOD NUMBER']]">{{germplasm.methodNumber}}</td>
				<td [hidden]="hiddenColumns[ColumnLabels['METHOD GROUP']]">{{germplasm.methodGroup}}</td>
				<td [hidden]="hiddenColumns[ColumnLabels['FGID']]" *jhiHasAnyAuthority="VIEW_PEDIGREE_INFORMATION_PERMISSION">
                    <span *ngIf="!this.germplasm.femaleParentGID || this.germplasm.femaleParentGID.length === 0"> - </span>
                    <span *ngIf="this.germplasm.femaleParentGID">
                        <jhi-expandable-cell [data]="this.germplasm.femaleParentGID"
                                             [asLink]="true"
                                             (itemClick)="germplasmDetailsPopupService.open(this.germplasm.femaleParentGID[$event])" ></jhi-expandable-cell>
                    </span>
                </td>
				<td [hidden]="hiddenColumns[ColumnLabels['CROSS-FEMALE PREFERRED NAME']]" *ngIf="showProgenitorNamesColumn()">
                    <span *ngIf="!this.germplasm.femaleParentPreferredName || this.germplasm.femaleParentPreferredName.length === 0"> - </span>
                    <span *ngIf="this.germplasm.femaleParentPreferredName">
                         <jhi-expandable-cell [data]="this.germplasm.femaleParentPreferredName"
                                              [asLink]="true"
                                              (itemClick)="germplasmDetailsPopupService.open(this.germplasm.femaleParentGID[$event])" ></jhi-expandable-cell>
                    </span>
                </td>
				<td [hidden]="hiddenColumns[ColumnLabels['MGID']]" *jhiHasAnyAuthority="VIEW_PEDIGREE_INFORMATION_PERMISSION">
                    <span *ngIf="!this.germplasm.maleParentGID || this.germplasm.maleParentGID.length === 0"> - </span>
                    <span *ngIf="this.germplasm.maleParentGID">
                        <jhi-expandable-cell [data]="this.germplasm.maleParentGID"
                                             [asLink]="true"
                                             (itemClick)="germplasmDetailsPopupService.open(this.germplasm.maleParentGID[$event])" ></jhi-expandable-cell>
                    </span>
                </td>
				<td [hidden]="hiddenColumns[ColumnLabels['CROSS-MALE PREFERRED NAME']]" *ngIf="showProgenitorNamesColumn()">
                    <span *ngIf="!this.germplasm.maleParentPreferredName || this.germplasm.maleParentPreferredName.length === 0"> - </span>
                    <span *ngIf="this.germplasm.maleParentPreferredName">
                        <jhi-expandable-cell [data]="this.germplasm.maleParentPreferredName"
                                             [asLink]="true"
                                             (itemClick)="germplasmDetailsPopupService.open(this.germplasm.maleParentGID[$event])" ></jhi-expandable-cell>
                    </span>
                </td>
				<td [hidden]="hiddenColumns[ColumnLabels['GROUP SOURCE GID']]" *jhiHasAnyAuthority="VIEW_PEDIGREE_INFORMATION_PERMISSION"><truncate-span [textInput]="germplasm.groupSourceGID"></truncate-span></td>
				<td [hidden]="hiddenColumns[ColumnLabels['GROUP SOURCE']]" *ngIf="showProgenitorNamesColumn()"><truncate-span [textInput]="germplasm.groupSourcePreferredName" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></td>
				<td [hidden]="hiddenColumns[ColumnLabels['IMMEDIATE SOURCE GID']]" *jhiHasAnyAuthority="VIEW_PEDIGREE_INFORMATION_PERMISSION"><truncate-span [textInput]="germplasm.immediateSourceGID"></truncate-span></td>
                <td [hidden]="hiddenColumns[ColumnLabels['IMMEDIATE SOURCE']]" *ngIf="showProgenitorNamesColumn()"><truncate-span [textInput]="germplasm.immediateSourceName"></truncate-span></td>
				<td *ngFor="let entry of germplasm.attributeTypesValueMap | keyvalue">{{entry.value}}</td>
				<ng-container *ngIf="showNamesColumn()">
					<td *ngFor="let entry of germplasm.nameTypesValueMap | keyvalue">{{entry.value}}</td>
				</ng-container>
			</tr>
			</tbody>
		</table>
		<ng-template #nodata>
			<table class="table table-striped table-bordered table-curved">
				<thead>
				<tr>
					<th></th>
				</tr>
				</thead>
				<tbody>
				<tr>
					<td jhiTranslate="no.data"></td>
				</tr>
				</tbody>
			</table>
		</ng-template>
	</div>
	<div *ngIf="germplasmList && germplasmList.length">
		<div class="row">
			<div class="col">
				<div class="pagination-container">
					<div class="pagination-box pagination-box-left">
						<div>
							<jhi-item-count-custom [page]="page" [total]="filteredItems" [itemsPerPage]="itemsPerPage"
												   [limit]="isBrowseAllResults ? filteredItems+1 : 5000"></jhi-item-count-custom>
						</div>
					</div>
					<div class="pagination-box" data-test="germplasmSearchResultsTablePagination">
						<ngb-pagination [collectionSize]="filteredItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
										[maxSize]="5" [rotate]="true" (pageChange)="loadPage(page)"></ngb-pagination>
					</div>
					<div class="pagination-box pagination-box-right">
						<div class="d-flex align-items-center">
							<label for="itemsPerPage" class="control-label control-label-left" jhiTranslate="global.items.per.page"></label>
							<select [(ngModel)]="itemsPerPage" class="form-select ms-2" id="itemsPerPage" [disabled]="isLoading" (change)="resetTable(); listBuilderContext.pageSize = itemsPerPage" style="width:95px">
								<option value="20">20</option>
								<option value="50">50</option>
								<option value="75">75</option>
								<option value="100">100</option>
							</select>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
